import { useCallback, useState } from "react";
import type { AdmissionCode } from "@shared/types/rejections.ts";

export interface UseRejectionCodeFilterResult {
  /** Narrows the list to items rejected for this code; null for all of them. */
  rejectionCode: AdmissionCode | null;
  setRejectionCode: (code: AdmissionCode | null) => void;
}

interface CodeOnTab {
  tab: string;
  code: AdmissionCode | null;
}

/** The rejection-code filter of a tabbed list. A code belongs to the tab it was picked on: it is
 *  cleared as soon as another tab shows. */
export function useRejectionCodeFilter(activeTab: string): UseRejectionCodeFilterResult {
  const [picked, setPicked] = useState<CodeOnTab | null>(null);

  // Adjusting state while rendering, rather than in an effect, so no render shows a code from
  // another tab.
  if (picked && picked.tab !== activeTab) setPicked(null);

  const setRejectionCode = useCallback(
    (code: AdmissionCode | null) => setPicked({ tab: activeTab, code }),
    [activeTab]
  );

  return { rejectionCode: picked?.tab === activeTab ? picked.code : null, setRejectionCode };
}
